import React from "react"

import { NumberInput } from "shared/ui/input/number/NumberInput"

import { useRoomFormContext } from "../../contexts/RoomFormContext"

export interface RoomAirVolumeInputProps {
  name: string
  className: string
  label: string
  color: string
  unit?: string
  hideLabel?: boolean
  autoFocus?: boolean
  testId?: string
}

export const RoomAirVolumeInput = React.memo(
  ({
    name,
    className,
    label,
    color,
    unit,
    hideLabel,
    autoFocus,
    testId
  }: RoomAirVolumeInputProps) => {
    const { isReadonly, isDisabled } = useRoomFormContext()

    return (
      <NumberInput.Root
        name={name}
        className={className}
        label={label}
        unit={unit}
        autoFocus={autoFocus}
        readonly={isReadonly}
        disabled={isDisabled}
        format={{ maximumFractionDigits: 2 }}
        data-testid={testId}
      >
        <div className="room-form-input">
          <div
            className="room-form-input__color"
            style={{ backgroundColor: color }}
          />
          <div className="room-form-input__content">
            {!hideLabel ? <NumberInput.Label showUnit /> : null}
            <NumberInput.Group>
              <NumberInput.Focus>
                <NumberInput.Input />
              </NumberInput.Focus>
            </NumberInput.Group>
            <NumberInput.Readonly showUnit />
          </div>
        </div>
        <NumberInput.ErrorMessage />
      </NumberInput.Root>
    )
  }
)
